// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_sKK","cls2":"ExportFormatModal-cls2_5fF ExportFormatModal-cls1_sKK"};